export function NavigationHover() {
  document.addEventListener('DOMContentLoaded', function () {
    const headerNavHead = document.getElementById('header_navigation_head');
    const headerNavBody = document.getElementById('header_navigation_body');
    const headerOverlay = document.getElementById('header_overlay');

    function addActiveClass() {
      headerNavHead.classList.add('active');
      headerNavBody.classList.add('active');
      headerOverlay.classList.add('active');
    }

    function removeActiveClass() {
      if (!headerNavHead.matches(':hover') && !headerNavBody.matches(':hover')) {
        headerNavHead.classList.remove('active');
        headerNavBody.classList.remove('active');
        headerOverlay.classList.remove('active');
      }
    }

    if (headerNavHead) {
      headerNavHead.addEventListener('mouseenter', addActiveClass);
      headerNavHead.addEventListener('mouseleave', removeActiveClass);
    }

    if (headerNavBody) {
      headerNavBody.addEventListener('mouseenter', addActiveClass);
      headerNavBody.addEventListener('mouseleave', removeActiveClass);
    }

    // aタグのクリックイベントを明示的に処理
    if (headerNavBody) {
      const links = headerNavBody.querySelectorAll('a');
      if (links.length) {
        links.forEach((link) => {
          link.addEventListener('click', function (event) {
            event.preventDefault(); // デフォルトの動作を一旦無効化
            const href = this.getAttribute('href'); // href属性を取得
            if (href) {
              window.location.href = href; // 通常のリンク遷移を実行
            }
          });
        });
      }
    }
  });
}

NavigationHover();
